'use strict';
/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.4
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */

  var defaultSettings = {
    method: 'scroll',
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  }; // Merge configs

  this.settings = Object.assign(defaultSettings, settings);
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.destroy = this.destroy.bind(this);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;

    if (typeof this.nextPageLinkElement !== 'undefined' && this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();

  if (this.clickActive) {
    
    // Store the original content
    this.originalLinkContent = this.nextPageLinkElement.innerHTML;
    
    // Set innerHTML instead of innerText to support HTML in loadingText
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      // Store the original content
      this.originalLinkContent = this.nextPageLinkElement.innerHTML;
      
      // Set innerHTML instead of innerText to support HTML in loadingText
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();

  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;

      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }

      this.initialize();
    }
  }.bind(this);

  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};

// Your initialization code
console.log("Infinite scroll script loaded");
  
// Define a variable to hold the Ajaxinate instance
var endlessScroll;

function initializeAjaxinate() {
  console.log("Initializing Ajaxinate");
  
  // Check if required elements exist
  const productGrid = document.querySelector('#product-grid');
  const pagination = document.querySelector('#expand_pagination');
  
  if (!productGrid || !pagination) {
    console.warn('Required elements for Ajaxinate not found. Grid:', !!productGrid, 'Pagination:', !!pagination);
    return;
  }
  
  // Destroy previous instance if it exists
  if (endlessScroll && typeof endlessScroll.destroy === 'function') {
    console.log('Destroying previous Ajaxinate instance');
    endlessScroll.destroy();
    endlessScroll = null;
  }
  
  try {
    endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#expand_pagination',
      loadingText: '<img src="https://cdn.shopify.com/s/files/1/0313/3200/8069/files/Dual_Ring-1s-51px.gif?v=1694092799">',
      callback: function() {
        console.log('New products loaded');
        removeDuplicateProducts();
      }
    });
    console.log('Ajaxinate initialized successfully');
  } catch (error) {
    console.error('Error initializing Ajaxinate:', error);
  }
}

function removeDuplicateProducts() {
  console.log('Checking for duplicate products');
  const productGrid = document.querySelector('#product-grid');
  if (!productGrid) return;
  
  let productIDs = new Set();
  let duplicatesFound = false;
  
  productGrid.querySelectorAll('.grid__item').forEach(item => {
    // Try different product ID attributes that might exist
    let prodID = item.getAttribute('data-custom-product-id') || 
                item.getAttribute('data-product-id') || 
                item.getAttribute('id') ||
                item.querySelector('[data-product-id]')?.getAttribute('data-product-id');
    
    if (!prodID) {
      console.warn('Product item without ID found:', item);
      return;
    }
    
    if (productIDs.has(prodID)) {
      console.log('Duplicate product found and removed:', prodID);
      item.remove(); // Remove the duplicate item
      duplicatesFound = true;
    } else {
      productIDs.add(prodID);
    }
  });
  
  return duplicatesFound;
}

// Wait for DOM content to be loaded
document.addEventListener("DOMContentLoaded", function() {
  console.log("DOM loaded, setting up Ajaxinate");
  
  // Wait a short time to ensure all elements are properly rendered
  setTimeout(() => {
    initializeAjaxinate();
    
    // Setup observer for content changes (sorting, filtering)
    setupContentObserver();
    
    // Setup special handling for sort dropdown
    setupSortDropdown();
  }, 100);
});

function setupContentObserver() {
  const productGrid = document.querySelector('#product-grid');
  if (!productGrid) {
    console.warn('Product grid not found, cannot observe changes');
    return;
  }
  
  // Observer for changes to the product grid (like sorting/filtering)
  const gridObserver = new MutationObserver(function(mutations) {
    let needsReinitialization = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // If significant changes detected, we might need to reinitialize
        needsReinitialization = true;
      }
    });
    
    if (needsReinitialization) {
      console.log('Significant changes detected in product grid');
      removeDuplicateProducts();
      
      // Check if pagination still exists after grid changes
      const pagination = document.querySelector('#expand_pagination');
      if (pagination && pagination.querySelector('a')) {
        console.log('Pagination still exists, reinitializing Ajaxinate');
        if (endlessScroll && typeof endlessScroll.destroy === 'function') {
          endlessScroll.destroy();
        }
        setTimeout(initializeAjaxinate, 300);
      }
    }
  });
  
  // Observe grid for child changes
  gridObserver.observe(productGrid, { childList: true });
  console.log('Grid observer initialized');
  
  // Listen for history changes (back/forward browser navigation)
  window.addEventListener('popstate', function() {
    console.log('Browser history changed (back/forward button)');
    setTimeout(initializeAjaxinate, 500);
  });
  
  // Listen for Shopify-specific events
  document.addEventListener('shopify:section:load', function() {
    console.log('Shopify section loaded');
    setTimeout(initializeAjaxinate, 500);
  });
  
  // Listen for collection:updated event
  document.addEventListener('collection:updated', function() {
    console.log('Collection updated event detected');
    setTimeout(initializeAjaxinate, 500);
  });
  
  // Add listeners for filter form submissions
  document.querySelectorAll('form.facets-vertical-form, form.filter-form, form.facet-filters__form').forEach(form => {
    form.addEventListener('submit', function(e) {
      console.log('Filter form submitted');
    });
  });
}

// Special handling for sort dropdown
function setupSortDropdown() {
  const sortBySelect = document.querySelector('#SortBy');
  if (!sortBySelect) {
    console.warn('Sort dropdown not found');
    return;
  }
  
  console.log('Setting up sort dropdown listener');
  
  sortBySelect.addEventListener('change', function(e) {
    console.log('Sort dropdown changed to:', this.value);
    
    // Prevent default behavior
    e.preventDefault();
    
    // Show loading indicator if exists
    const loadingOverlay = document.querySelector('.loading-overlay__spinner');
    if (loadingOverlay) loadingOverlay.style.display = 'block';
    
    // Get current URL and update sort parameter
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    const newUrl = url.toString();
    
    // Fetch the sorted page content
    fetch(newUrl)
      .then(response => response.text())
      .then(html => {
        // Parse the HTML response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Get new content
        const newProductGrid = doc.querySelector('#product-grid');
        const newPagination = doc.querySelector('#expand_pagination');
        
        // Update the product grid
        if (newProductGrid) {
          const currentGrid = document.querySelector('#product-grid');
          if (currentGrid) {
            console.log('Updating product grid with sorted results');
            currentGrid.innerHTML = newProductGrid.innerHTML;
          }
        }
        
        // Update the pagination
        if (newPagination) {
          const currentPagination = document.querySelector('#expand_pagination');
          if (currentPagination) {
            console.log('Updating pagination');
            currentPagination.innerHTML = newPagination.innerHTML;
          }
        }
        
        // Update URL without page reload
        history.pushState({}, '', newUrl);
        
        // Hide loading indicator
        if (loadingOverlay) loadingOverlay.style.display = 'none';
        
        // Reinitialize infinite scroll
        console.log('Reinitializing Ajaxinate after sorting');
        setTimeout(function() {
          if (endlessScroll && typeof endlessScroll.destroy === 'function') {
            endlessScroll.destroy();
          }
          initializeAjaxinate();
        }, 100);
      })
      .catch(error => {
        console.error('Error during sort fetch:', error);
        if (loadingOverlay) loadingOverlay.style.display = 'none';
      });
  });
}

// Reinitialize when a facet filter form changes
function setupFacetFilters() {
  // Get all facet filter forms
  const facetForms = document.querySelectorAll('facet-filters-form');
  
  facetForms.forEach(form => {
    form.addEventListener('change', function() {
      console.log('Facet filter changed');
      // Filters typically submit the form, so we'll just let that happen normally
    });
  });
  
  // Also watch for changes in facet filters via MutationObserver
  const facetsContainer = document.querySelector('.facets-container');
  if (facetsContainer) {
    const facetsObserver = new MutationObserver(function(mutations) {
      let facetsChanged = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          facetsChanged = true;
        }
      });
      
      if (facetsChanged) {
        console.log('Facets container changed');
        setTimeout(initializeAjaxinate, 500);
      }
    });
    
    facetsObserver.observe(facetsContainer, { 
      childList: true, 
      attributes: true,
      subtree: true
    });
  }
}

// Call this when document is loaded
document.addEventListener('DOMContentLoaded', function() {
  setupFacetFilters();
});